const React = require('react');
const isNode = (typeof process !== 'undefined');

class TextBoxes extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { boxes } = this.props;
        return (
            <section className="boxes">
                <div className="boxes__wrapper">
                    {boxes.map((box, i) => {
                        const { link, description, title, externalLink } = box;
                        return (
                            <div className="boxes__box">
                                <div className="boxes__content">
                                    <h2 className="boxes__title">{title}</h2>
                                    {description && <div className="boxes__description" dangerouslySetInnerHTML={{__html: description}}/>}
                                    {link && <a className="boxes__link" href={link}>Les mer</a>}
                                    {externalLink && <a className="boxes__link" href={externalLink}>Les mer</a>}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </section>
        )

    }
}

module.exports = TextBoxes;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/textboxes/Component/index.jsx